import { useCallback } from 'react'
import { useDialogStore, type DialogState } from '../useDialogStore/useDialogStore'

export type SetDialogStateHookReturn<T> = (open: DialogState<T>['open'], data?: DialogState<T>['data']) => void

/**
 * @deprecated Use `useDialog` from `lib/hooks/useDialog/useDialog` instead.
 * This is a low-level write-only hook — `useDialog` combines it with `useDialogState` in a single call.
 */
export const useSetDialogState = <T>(id: string): SetDialogStateHookReturn<T> => {
  const setState = useDialogStore(({ setState }) => setState)

  return useCallback(
    (open, data) => {
      setState(id, open, data)
    },
    [id, setState],
  )
}
